import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const CardPrinterOverview = ({ data }) => {
  const {
    of_cpfh_company_name,
    of_cpfh_name,
    of_cpfh_desk,
    of_cpfh_email,
    of_cpfh_card_manufacturer,
    of_cpfh_other_networks,
  } = data["2_1"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="fw-700 review-summary-sub-heading review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading  title="Card Printer / Fulfillment House"/>
        </div>
        <ReviewAttribute
          label="Company"
          value={
            of_cpfh_company_name?.length
              ? toTitleCase(of_cpfh_company_name)
              : "-"
          }
        />
        <ReviewAttribute
          label="Name"
          value={of_cpfh_name?.length ? toTitleCase(of_cpfh_name) : "-"}
        />
        <ReviewAttribute
          label="Desk"
          value={of_cpfh_desk?.length ? toTitleCase(of_cpfh_desk) : "-"}
        />
        <ReviewAttribute
          label="Email"
          value={of_cpfh_email?.length ? of_cpfh_email : "-"}
        />
        <ReviewAttribute
          label="Card Manufacturer – PCI compliant"
          value={
            of_cpfh_card_manufacturer?.length
              ? toTitleCase(of_cpfh_card_manufacturer)
              : "-"
          }
        />
        <ReviewAttribute
          label="Other Networks/Vendor Integrations"
          value={
            of_cpfh_other_networks?.length
              ? toTitleCase(of_cpfh_other_networks)
              : "-"
          }
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default CardPrinterOverview;
